import { connect } from "react-redux";
import EmployeesIndex from "../../components/Employees/Index";
import { initial } from "lodash";
import {
  getRoles,
  getClientRoles,
  sendInvite,
  rollBackStatus,
  getTableList,
  updateProfile,
  rollBackUpdateStatus,
  sendClientUserInvite,
} from "../../actions/employees";

const mapStateToProps = state => {
  const {
    roles,
    clientRoles,
    ifSendInviteSuccess,
    tableList,
    ifUpdateSuccess,
    updateErrorText,
    sendInvite_error_message,
  } = state.employees;
  const { userId, clients, roleId, selected_client } = state.app;
  const isAdminSelect =
    typeof selected_client === "string" && selected_client.indexOf("r-") >= 0;
  return {
    roles: roleId > 50 ? clientRoles.filter(item => item.value !== 53) : roles,
    clientRoles: initial(clientRoles),
    ifSendInviteSuccess,
    tableList: tableList.data,
    origin_tableList: tableList,
    ifUpdateSuccess,
    updateErrorText,
    userId,
    roleId,
    selected_client: isAdminSelect
      ? clients
        ? clients[0].id
        : selected_client
      : selected_client,
    sendInvite_error_message,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    getRoles: () => {
      dispatch(getRoles());
    },
    getClientRoles: () => {
      dispatch(getClientRoles());
    },
    sendInvite: obj => {
      dispatch(sendInvite(obj));
    },
    sendClientInvite: obj => {
      dispatch(sendClientUserInvite(obj));
    },
    rollBackStatus: () => {
      dispatch(rollBackStatus());
    },
    getTableList: (obj, clientId) => {
      dispatch(getTableList(obj, clientId));
    },
    updateProfile: (id, obj) => {
      dispatch(updateProfile(id, obj));
    },
    rollBackUpdateStatus: () => {
      dispatch(rollBackUpdateStatus());
    },
  };
};

const Employees = connect(
  mapStateToProps,
  mapDispatchToProps,
)(EmployeesIndex);

export default Employees;



// WEBPACK FOOTER //
// ./src/containers/Employees/index.js